import React from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { filterChange } from '../../actions/index';

import Select from '@material-ui/core/Select';
import MenuItem from '@material-ui/core/MenuItem';
import { _ } from '../../functions/translator.js';
import Checkbox from '@material-ui/core/Checkbox';
import ListSubheader from '@material-ui/core/ListSubheader';
import { findProtocolGroup, findProtocolName } from '../../functions/finder';
import { FilterActions } from '../../constants/constants';

const MenuProps = {
    PaperProps: {
        style: {
            maxHeight: 500,
            top: '0px',
            position: 'fixed',
        },
    },
    getContentAnchorEl: null,
};

class AnnexesDropdown extends React.Component{

    handleProtocolsChange = (event) => {
        let protocolIdsSelected = [];
        let protocolgroupSelected = null;
        for (const protocolIdSelected of event.target.value) {
            const isAProtocolgroup = typeof protocolIdSelected === 'object';
            if (isAProtocolgroup) {
                protocolgroupSelected = protocolIdSelected;
            } else {
                protocolIdsSelected.push(protocolIdSelected);
            }
        }
        if (protocolgroupSelected) {
            protocolIdsSelected = this.handleProtocolgroupSelected(protocolIdsSelected, protocolgroupSelected);
        }
        this.props.filterChange(FilterActions.PROTOCOLS, protocolIdsSelected);
    }

    handleProtocolgroupSelected = (protocolIdsSelected, protocolgroupSelected) => {
        let protocolIds = Object.keys(protocolgroupSelected.protocols).map((protocolIdStr) => {
            return parseInt(protocolIdStr);
        })
        let protocolsSelected = protocolIds.map((protocolId) => { 
            return protocolIdsSelected.indexOf(protocolId) !== -1;
        });
        const areAllProtocolsSelected = !protocolsSelected.includes(false);
        if (areAllProtocolsSelected) {
            protocolIdsSelected = protocolIdsSelected.filter((protocolId) => {
                return !protocolIds.includes(protocolId);
            });
        } else {
            protocolIds.forEach((protocolId) => {
                if (!protocolIdsSelected.includes(protocolId)) {
                    protocolIdsSelected.push(protocolId);
                }
            });
        }
        return protocolIdsSelected;
    }

    renderProtocolsSelected = (selected) => {
        if (selected.length === 0) {
            return _('Anexos');
        } else {
            let protocolNames = []
            for (const protocolId of selected) {
                let protocolName = findProtocolName(protocolId, this.props.protocolgroupsData)
                protocolNames.push(protocolName)
            }
            return protocolNames.join(', ')
        }
    }

    hasAStageSelected(protocolStages) {
        if (this.props.stageIds.length === 0) {
            return true
        }
        for (const stageId of Object.keys(protocolStages)) {
            if (this.props.stageIds.includes(parseInt(stageId))) {
                return true
            }
        }
        return false
    }

    hasAProtocolSelected(protocolgroupData) {
        for (const protocolData of Object.values(protocolgroupData.protocols)) {
            if (this.props.protocolIds.includes(protocolData.id)) {
                return true
            }
        }
        return false
    }

    componentDidUpdate(prevProps) {
        if (prevProps.protocolgroupIds !== this.props.protocolgroupIds) {
            let protocols = [...this.props.protocolIds]
            for (const protocolgroupId of this.props.protocolgroupIds) {
                let protocolgroupData = this.props.protocolgroupsData[protocolgroupId.toString()]
                let hasAProtocolSelected = this.hasAProtocolSelected(protocolgroupData)
                for (const protocol of Object.values(protocolgroupData.protocols)) {
                    if (!this.hasAStageSelected(protocol.stages)) continue
                    if (!protocols.includes(protocol.id) && !hasAProtocolSelected) {
                        protocols.push(protocol.id)
                    }
                }
            }
            protocols = protocols.filter((protocolId) => {
                let protocolgroupData = findProtocolGroup(protocolId, this.props.protocolgroupsData)
                return this.props.protocolgroupIds.includes(protocolgroupData.id)
            })
            if (this.props.protocolIds.length !== protocols.length) {
                this.props.filterChange(FilterActions.PROTOCOLS, protocols)
            }
        }
    }

    render() {
        let stageProtocolIds = []
        for (const stageData of Object.values(this.props.stagesData)) {
            if (this.props.stageIds.length > 0 && !this.props.stageIds.includes(stageData.id)) continue
            stageProtocolIds = stageProtocolIds.concat(
                Object.keys(stageData.protocols).map((protocolId) => { return parseInt(protocolId) })
            )
        }
        
        const options = []
        if (this.props.protocolgroupIds.length > 0) {
            for (const protocolgroupId of this.props.protocolgroupIds) {
                let protocolgroupData = this.props.protocolgroupsData[protocolgroupId.toString()]
                options.push(
                    <ListSubheader color="inherit" value={protocolgroupData} classes={{root: 'cursor-pointer'}}>
                        {protocolgroupData.attributes.name}
                    </ListSubheader>
                )
                for (const protocol of Object.values(protocolgroupData.protocols)) {  
                    if (stageProtocolIds.includes(protocol.id)) {
                        options.push(
                            <MenuItem key={protocol.id} value={protocol.id}>
                                <Checkbox color="primary" checked={this.props.protocolIds.includes(protocol.id)} />
                                {protocol.attributes.name}
                            </MenuItem>
                        )
                    }
                }
            }
        }

        return(
            <div>
                <Select
                value={this.props.protocolIds}
                multiple={true}
                displayEmpty={true}
                renderValue={this.renderProtocolsSelected}
                onChange={this.handleProtocolsChange}
                MenuProps={MenuProps}>
                {options}
                </Select>
            </div>
        );
    }
}

function mapStateToProps( state ){
    return {
        stageIds           : state.filters.stageIds,
        stagesData         : state.projectData.stages,
        protocolIds        : state.filters.protocolIds,
        protocolgroupIds   : state.filters.protocolgroupIds,
        protocolgroupsData : state.projectData.protocolgroups
    }
}

function matchDispatchToProps( dispatch ){
    return bindActionCreators({ 
        filterChange     : filterChange
    }, dispatch)
}

export default connect(mapStateToProps, matchDispatchToProps)(AnnexesDropdown);